import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';

// The globe ships in its own chunk: the home page never pays for it.
const GlobePage = lazy(() => import('./pages/GlobePage'));

export default function App() {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route
				path="/globe"
				element={
					<Suspense fallback={<div className="fixed inset-0 bg-[#030014]" />}>
						<GlobePage />
					</Suspense>
				}
			/>
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
